import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'rmt-menu-button',
  templateUrl: 'rmt-menu-button.html'
})
export class RmtMenuButtonComponent {

  @Output() menuAction = new EventEmitter();
  @Input() menuItems;
  @Input() selectedButton;

  constructor() {
  }


  onMenuClick(event, title) {
    if (this.selectedButton === title) {
      this.selectedButton = "page.activityPage.allButton";
    } else {
      this.selectedButton = title;
    }
    this.menuAction.emit(this.selectedButton);
  }


}



// WEBPACK FOOTER //
// ./src/components/rmt-menu-button/rmt-menu-button.ts